import { getTenantRoles,getTenantUserSubscriptionConfig } from "../../../services/tenantUserService";

const schema = async (data) => {
  let s = {
    type: "object",
    properties: {
      tenantId: {
        type: "string",
        oneOf: data.tenants.map((r) => ({
          const: r.id,
          title: r.name,
        })),
        format: "uuid",
      },
      tenantUserRoleId: {
        type: "string",
        oneOf: [{ const: "", title: "" }],
        minLength: 1,
        format: "uuid",
      },
    },
    required: ["tenantId", "tenantUserRoleId"],
  };

  if (data.tenantId) {
    const tenantRoles = await getTenantRoles(data.tenantId);

    const res = await getTenantUserSubscriptionConfig(data.tenantId);

    if (res.data.value) {
      s = {...s,
        properties: {
          ...s.properties,
          expiresAt: {
            type: ["string", "null"]
          }
        }};
    }

    s.properties.tenantUserRoleId.oneOf = tenantRoles.data.map((r) => ({
      const: r.id,
      title: r.name,
    }));
  }
  return s;
};

export default schema;
